import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import React from "react";
import { sizes } from "../../../../constants/spacing";
import { Spinner } from "../../../spinner";
var LoadingOptionContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: ", "px;\n"])), sizes.medium);
export var LoadingOption = function LoadingOption() {
  return /*#__PURE__*/React.createElement(LoadingOptionContainer, {
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "medium"
  }));
};
//# sourceMappingURL=LoadingOption.js.map